import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routes from './routes';
import { Toaster } from 'sonner';

const router = createBrowserRouter(routes);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
    <Toaster 
      toastOptions={{
        style: {
          height: '100px',
          width: '350px',
        }
      }} 
      richColors
      position="top-center"
    />
  </React.StrictMode>
);

reportWebVitals();
